import { render, staticRenderFns } from "./RightClickComponent.vue?vue&type=template&id=7920d1fd"
import script from "./RightClickComponent.vue?vue&type=script&lang=js"
export * from "./RightClickComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports